export default __webpack_public_path__ + "static/media/bg-About-Us.332ee573.jpg";